export default {
  namespaced: true,

  state: () => ({
    settings: {
      data: [],
      links: {},
      meta: {},
    },
    setting: {},
    isLoading: false,
    listTypeOption: [
      {
        value: 'boolean',
        title: 'Switch',
        active: true,
      },
      {
        value: 'text',
        title: 'Text',
        active: true,
      },
      {
        value: 'longtext',
        title: 'Deskripsi',
        active: true,
      },
      {
        value: 'number',
        title: 'Angka',
        active: true,
      },
      {
        value: 'file',
        title: 'File',
        active: false,
      },
      {
        value: 'image',
        title: 'Gambar',
        active: false,
      },
    ],
  }),

  mutations: {
    SET_SETTINGS_LIST(state, payload) {
      state.settings = payload
    },
    SET_SETTING(state, payload) {
      state.setting = payload
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload
    },
    RESET_SETTINGS_LIST(state) {
      state.settings = {
        data: [],
        links: {},
        meta: {},
      }
    },
  },

  actions: {
    // get
    async getSettingsList({ commit }, { page = null, keyword = '' } = {}) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/settings?filter[name]=${keyword}`

        const response = await this._vm.$http.get(url, { params: { page } })

        commit('SET_SETTINGS_LIST', response.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    // show
    async getSetting({ commit }, { key }) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/settings/${key}`

        const response = await this._vm.$http.get(url)

        commit('SET_SETTING', response.data.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        return error
      }
    },
    // delete
    async deleteSetting({ commit, dispatch }, { settingKey }) {
      try {
        const url = `/v1/admin/settings/${settingKey}`

        const response = await this._vm.$http.delete(url)

        dispatch('getSettingsList')

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Pengaturan!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Pengaturan!',
        }, { root: true })

        return error
      }
    },
    // create
    async createSetting({ commit }, data) {
      try {
        const url = '/v1/admin/settings'

        const formData = new FormData()
        formData.append('name', data.name)
        formData.append('key', data.key)
        formData.append('value', data.value)
        formData.append('type', data.type)

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Pengaturan!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Pengaturan!',
        }, { root: true })

        return error
      }
    },
    // edit
    async updateSetting({ commit }, { settingKey, data }) {
      try {
        const url = `/v1/admin/settings/${settingKey}`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Pengaturan!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Pengaturan!',
        }, { root: true })

        return error
      }
    },
  },
}
